import { useState } from "react";

type CollapsedState = {
  isExpanded: boolean;
  visibleCount: number;
};

export const useCollapsedTags = (
  tags: string[],
  maxVisible = 2,
): CollapsedState & {
  toggle: () => void;
  collapse: () => void;
} => {
  const [isExpanded, setIsExpanded] = useState(false);

  return {
    isExpanded,
    visibleCount: isExpanded ? tags.length : maxVisible,
    toggle: () => setIsExpanded((prev) => !prev),
    collapse: () => setIsExpanded(false),
  };
};
